/* THE VERB, MADE REAL.
 *
 * The shop is named after a bite and for three worlds the bite was never once
 * visible. This machinery already existed — `data-chomp-react`, a `vault:chomp`
 * event dispatched by cart.js on a successful add — and it was pointed at
 * `snap`, a POINTING pose. So the one moment the whole brand is named after
 * swapped the mascot for a shrug, after the fact, where nobody looked.
 *
 * Three states now:
 *   rest    he holds the find
 *   ready   you are hovering CHOMP — his jaws open, the find braces
 *   bite    you pressed it — he bites and the find is gone
 *
 * The card is a separate element sitting behind a hole in his artwork, so it
 * has to be animated by CSS rather than baked into the stamp; `.is-ready` and
 * `.is-bite` on the mascot are what vault.craft.css hangs that off.
 */

const reactive = document.querySelectorAll("[data-jf-mascot][data-chomp-react]");
const reduce = document.documentElement.getAttribute("data-motion") === "reduce";

function paint(name) {
  for (const root of reactive) {
    const src = root.getAttribute(`data-src-${name}`);
    if (!src) continue;
    const img = root.querySelector("[data-chomp-img]");
    root.setAttribute("data-chomp", name);
    root.classList.toggle("is-bite", name === "bite");
    if (img) img.setAttribute("src", src);
  }
}

/* Anticipation. Jaws open while the pointer is on the button, and the find is
   still in his fins — the bite has not happened yet. */
function ready(on) {
  for (const root of reactive) {
    const bite = root.getAttribute("data-src-bite");
    const rest = root.getAttribute("data-src-rest");
    if (!bite || !rest) continue;
    if (root.classList.contains("is-bite")) continue;
    const img = root.querySelector("[data-chomp-img]");
    root.classList.toggle("is-ready", on);
    if (img) img.setAttribute("src", on ? bite : rest);
  }
}

if (reactive.length) {
  const rest = () => {
    for (const root of reactive) root.classList.remove("is-ready", "is-bite");
    paint(reactive[0].dataset.chompRest || "idle");
  };

  window.addEventListener("vault:sonar", () => paint("sonar"));
  window.addEventListener("vault:hungry", () => paint("hungry"));
  window.addEventListener("vault:lost", () => paint("lost"));

  /* The bite itself. Held long enough to read as an event rather than a
     flicker — the find has to visibly leave. */
  window.addEventListener("vault:chomp", () => {
    for (const root of reactive) root.classList.remove("is-ready");
    paint("bite");
    setTimeout(rest, reduce ? 260 : 1150);
  });

  if (!reduce) {
    for (const btn of document.querySelectorAll(".chomp-btn")) {
      if (btn.disabled) continue;
      btn.addEventListener("pointerenter", () => ready(true));
      btn.addEventListener("pointerleave", () => ready(false));
      btn.addEventListener("focus", () => ready(true));
      btn.addEventListener("blur", () => ready(false));
    }
  }
}
